var _circle, _g, _path, _path2, _g2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 508 508"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 254,
    cy: 254,
    r: 254,
    fill: "#00a9a9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#e6e9ee"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.2 363.2c-.4 0-.8.4-1.6.4-.4 0-.8-.4-1.6-.4h3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.4 404c-46 62.8-120.8 104-204.8 104S95.2 467.2 48.8 404c36-38.4 84.8-58.8 125.6-69.2-3.6 29.2 11.6 68.4 12 67.2 15.2-35.2 66.8-38.4 66.8-38.4s51.6 2.8 67.2 38.4c.4.8 15.6-38 12-67.2 41.2 10.4 90 30.8 126 69.2z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M316.8 308c0 5.2-3.2 32.8-61.6 55.2H252c-58.4-22.4-61.6-50-61.6-55.2.4-10.4 2.8-20.8 7.2-30.4 16 18 35.2 30 56 30 20.4 0 40-11.6 56-30 4.4 9.6 7.2 20 7.2 30.4z",
    fill: "#ffd05b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M288.4 372.4L275.6 398h-44l-12.8-25.6c17.6-7.6 34.8-8.8 34.8-8.8s17.6 1.2 34.8 8.8zM218 505.6c11.6 1.6 23.6 2.4 36 2.4 12 0 24-.8 36-2.4l-14-107.2h-44l-14 107.2z",
    fill: "#00a9a9"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.8 307.2s2.8 32-63.2 56.4c0 0 51.6 2.8 67.2 38.4.4 1.6 30.4-76-4-94.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.4 307.2c-34 18.8-4.4 96-3.6 94.8 15.2-35.2 67.2-38.4 67.2-38.4-66.4-24.4-63.6-56.4-63.6-56.4z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M312.8 285.6c-16.8 18-36.8 29.6-59.2 29.6s-42.4-11.6-59.2-29.6c.8-2.8 2-5.6 3.2-8 16 18 35.2 30 56 30s40-11.6 56-30c1.2 2.4 2.4 5.2 3.2 8z",
    fill: "#f9b54c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M362.8 224.4c-8.4 14-21.2 22.4-30.8 20.8-19.2 35.6-47.2 62-78.4 62s-59.2-26.8-78.4-62c-9.6 1.2-22.4-6.8-30.8-20.8-10-16.4-10.4-34.4-.8-40.4 2.4-1.2 4.8-2 7.6-1.6 6.4 16.4 15.2 26.4 15.2 26.4-9.2-50.8 28.4-56.4 22-105.2 0 0 23.6 52.4 91.2 15.6l-5.2 10c94.4-21.2 62.8 90 62 92.8 10.8-13.6 17.6-27.2 21.6-39.6 1.6 0 3.6.8 4.8 1.6 10.4 5.6 10 24 0 40.4z",
    fill: "#ffd05b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M308 50.8c7.6-.8 20 6 20 6-34-38.8-89.6-14-89.6-14 18.8-16 35.6-14.4 35.6-14.4-79.6-12-93.2 35.6-93.2 35.6-3.6-5.6-3.6-13.6-3.2-17.6-5.6 9.6.4 28.8.4 28.8-5.6-14-25.2-11.6-25.2-11.6 16.8 2.8 19.6 13.2 19.6 13.2-42 15.6-34.8 59.2-34.8 59.2l10-12c-12.4 47.6 19.2 84.4 19.2 84.4-9.2-50.8 28.4-56.4 22-105.2 0 0 23.6 52.4 91.2 15.6l-5.2 10c95.6-21.6 62 93.2 62 93.2 34-43.2 28.8-87.6 28.8-87.6l4 16c10.8-72-61.6-99.6-61.6-99.6z",
    fill: "#324a5e"
  })));
}
export default __webpack_public_path__ + "030bcbd425796215f7d15c0761f19e33.svg";
export { SvgProfile as ReactComponent };